package com.zq.my_official_website

/**
 * application/x-www-form-urlencoded 风格的百分号编码（UTF-8 字节序列）。
 */
internal fun percentEncodeQueryComponent(s: String): String {
    val bytes = s.encodeToByteArray()
    return buildString(bytes.size * 3) {
        for (b in bytes) {
            val v = b.toInt() and 0xFF
            when (v) {
                in 'A'.code..'Z'.code -> append(v.toChar())
                in 'a'.code..'z'.code -> append(v.toChar())
                in '0'.code..'9'.code -> append(v.toChar())
                '-'.code, '_'.code, '.'.code, '~'.code -> append(v.toChar())
                else -> {
                    append('%')
                    append(hexDigit(v shr 4))
                    append(hexDigit(v and 0x0F))
                }
            }
        }
    }
}

private fun hexDigit(n: Int): Char {
    val c = n and 0x0F
    return if (c < 10) ('0'.code + c).toChar() else ('A'.code + (c - 10)).toChar()
}
